import React, { useContext, useState } from 'react';
import {
    TextField,
    Button,
    Container,
    Grid,
    makeStyles,
    Typography,
    Modal,
    Paper, CardContent, IconButton, Snackbar
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Link, Navigate, useNavigate } from "react-router-dom";
import AppState from '../../context/AppContext'
import "../../styles/pages/loginRegister.scss";

const useStyles = makeStyles((theme) => ({
    input: {
        minWidth: '360px',
        backgroundColor: 'white',
        color: 'black',
        '& .MuiFormHelperText-root': {
            color: 'black',
        },
        '& .Mui-error': {
            color: 'black',
        },
    },
    errorText: {
        color: 'white',
        fontSize: '14px',
        fontWeight: 'bold',
    },
    card: {
        marginTop: '20px',
    },
    loginText: {
        color: 'white',
        fontWeight: 'bold',
        fontFamily: '"Great Vibes", cursive',
    },
    error: {
        verticalAlign: "middle",
    },
    loginButton: {
        backgroundColor: 'green',
        color: 'white',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        margin: 'auto',
        maxWidth: '320px',
        padding: theme.spacing(2),
    },
    typography: {
        marginTop: theme.spacing(2),
    },
    cardModal: {
        width: '100%',
    },
    closeButton: {
        float: 'right'
    },
}));

const Login = () => {
    const context = useContext(AppState)
    const classes = useStyles();
    const navigate = useNavigate()
    const [formValues, setFormValues] = useState({
        email: '',
        password: '',
        error: '',
        redirectToReferrer: false
    });
    const [emailError, setEmailError] = useState('');
    const [modalOpen, setModalOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [open, setOpen] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value,
        });
    }
    const handleSubmit = async( event ) => {
        event.preventDefault();
            const user = {
                email: formValues.email || undefined,
                password: formValues.password || undefined,
            };
            await context.login( user ).then( ( data ) => {
                if( data ) {
                    context.setUser( data )
                    sessionStorage.setItem( 'user', JSON.stringify( data ) );
                    setFormValues( { ...formValues, error:'', redirectToReferrer: true } )
                }
            } ).catch( ( error ) => {
                setFormValues( {
                    ...formValues,
                    error: error.response.data.message
                } );
            } );
    }
    const handleCancel = () => {
        setFormValues({
            email: '',
            password: '',
            error: '',
            redirectToReferrer: false
        });
    }
    const handleEmailChange = (event) => {
        const email = event.target.value;
        setEmail(email);
        if (email.includes('@') && email.includes('.')) {
            setEmailError('');
        } else {
            setEmailError('Please enter a valid email address');
        }
    }

    const handleSend = () => {
        if( !email || emailError ) {
            setEmailError( 'Please enter a valid email address' );
        } else {
            const userEmail ={
                email:email
            }
            context.resetPasswordViaEmail(userEmail)
            setOpen(true)
            setModalOpen(false)
        }
    }

    const handleCancelModal = () => {
        setEmailError('')
        setModalOpen(false);
    }
    const handleSnackbarClose = (event, reason) => {
        navigate("/login")
        if (reason === 'clickaway') {
            return;
        }
        setEmail('')
        setOpen(false);
        navigate("/login")
    };
    if(formValues.redirectToReferrer) return <Navigate to='/'/>
    return (
        <div className={classes.card}>
        <Container>
            <Typography variant="h3" align="center" className={classes.loginText}>Log into your account</Typography>
            <br />
            <br />

            <Grid container justifyContent="center" alignItems="center" spacing={3}>
                <form onSubmit={handleSubmit}>
                <label>Username/E-Mail</label>
                    <Grid item xs={12}>
                        <TextField
                            label="Email"
                            type="email"
                            name="email"
                            value={formValues.email}
                            onChange={handleChange}
                            className={classes.input}
                        />

                    </Grid>
                    <br />
                    <label>Password</label>
                    <Grid item xs={12}>
                        <TextField
                            label="Password"
                            type="password"
                            name="password"
                            value={formValues.password}
                            onChange={handleChange}
                            className={classes.input}
                        />
                    </Grid>
                    <br />
                    <div>
                        <Link onClick={() => setModalOpen(true)} className='hover-underline-animation'>
                            {'Forgot Password?'}
                        </Link>
                        <Modal open={modalOpen} className={classes.modal}>
                            <Paper className={classes.paper}>
                                <IconButton className={classes.closeButton} onClick={handleCancelModal}>
                                    <Close />
                                </IconButton>
                                <Typography variant="h5">What is my password?</Typography>
                                <Paper className={classes.card}>
                                    <CardContent>
                                        <Typography variant="body1">
                                            If you have forgotten your password, you can reset it here!
                                        </Typography>
                                        <TextField label="Email" type="email" name="email" value={email} onChange={handleEmailChange} error={!!emailError} helperText={emailError} /><br/><br/><br/>
                                        <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
                                            <Grid item>
                                                <Button variant="contained" color="primary" onClick={handleSend}>
                                                    Send
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button variant="contained" onClick={handleCancelModal}>
                                                    Cancel
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Paper>
                            </Paper>
                        </Modal>
                    </div>
                    <br /> <br />
                    <Grid item xs={12} md={12}>
                        <Button variant="contained" className={classes.loginButton} onClick={handleSubmit}>Login</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="contained" onClick={handleCancel}>Cancel</Button>
                        {formValues && (
                            <p>{formValues.error}</p>
                        )}
                    </Grid>
                    <br/>
                    <br />
                    <Snackbar
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        open={open}
                        onClose={handleSnackbarClose}
                        message={`If there is an account associated with your ${email} than an email has been sent to reset password!`}
                        action={
                            <IconButton size="small" aria-label="close" color="inherit" onClick={handleSnackbarClose}>
                                <Close fontSize="small" />
                            </IconButton>
                        }
                    />
                    <Link to="/register" className='hover-underline-animation'>Do not have an account? Sign up</Link>
                    <br /> <br />
                </form>
            </Grid>
        </Container>
        </div>
    );
}

export default Login;
